<app-filter-container>
    <form [formGroup]="filterForm">
        <app-form-section>
            <app-form-row>
                <h1>{{ 'MENU.LOCATION' | translate }}</h1>
                <div class="content" *ngIf="locationPermissions.includes(permissions.WriteLocation)">
                    <button (click)="openCreateLocationModal()" class="primary" type="button">
                        {{ 'BUTTONS.CREATE_LOCATION' | translate }}
                        <span class="material-symbols-rounded trailing" aria-hidden="true"> add_2 </span>
                    </button>
                </div>
            </app-form-row>
            <app-form-row>
                <app-search-input formControlName="searchPhrase" />
            </app-form-row>
        </app-form-section>
    </form>
</app-filter-container>
<app-table [loading]="loading" [clickable]="true">
    <tr thead>
        <app-table-header
            [isActive]="sortKey === 'name'"
            [defaultAscending]="sortKey === 'name' && sortAscending"
            [sort]="true"
            [dynamicWidth]="100"
            [text]="'FEATURES.LOCATION.COLUMNS.NAME' | translate"
            (sortChanged)="onSortChange('name', $event)"
        />
        <app-table-header
            *ngIf="isUnrestricted"
            [isActive]="sortKey === 'tenantName'"
            [defaultAscending]="sortKey === 'tenantName' && sortAscending"
            [sort]="true"
            [width]="20"
            [text]="'GENERAL.TENANT' | translate"
            (sortChanged)="onSortChange('tenantName', $event)"
        />
        <app-table-header [align]="align.Center" [width]="8" *appHasPermissions="[permissions.WriteLocation]" />
    </tr>
    <ng-container tbody>
        <tr *ngFor="let item of locations$ | async" (click)="openCreateLocationModal(item)">
            <td>{{ item.name }}</td>
            <td *ngIf="isUnrestricted">{{ item.tenantName }}</td>
            <td class="center" *appHasPermissions="[permissions.WriteLocation]">
                <button
                    *ngIf="item.isDeletable"
                    (click)="confirmDeleteLocation($event, item)"
                    class="icon"
                    [ngClass]="{ loading: loadingLocationIds.includes(item.id) }"
                >
                    <span class="material-symbols-rounded" aria-label="Delete"> delete </span>
                </button>
            </td>
        </tr>
    </ng-container>
</app-table>
